import ResourceTable from '@/contexts/frontoffice/library/ui/components/ResourceTable'
import { Container } from '@mui/material'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Header from '../../../../shared/components/Header'
import useSkeleton from '../../../../shared/components/layouts/SkeletonLayout'
import ContentFilter from '../../../../shared/components/layouts/filters/ContentFilter'
import SubHeader from '../../../../shared/styles/Subheader'
import LibraryContentCards from '../components/LibraryContentCards'
import ResourceNotifications from '../components/ResourceNotifications'
import ResourceTypeFilter from '../components/ResourceTypeFilter'
import useHandleFilters from '../hooks/useHandleFilters'
import useHandlePagination from '../hooks/useHandlePagination'
import useResourceActions from '../hooks/useResourceActions'

function ClientLibrary() {
  const { t } = useTranslation(['global'])

  const { filters, setFilters, handleChangeFilter } = useHandleFilters()
  const { display, handleSearch, handleDownload, handleFavorite, handleClickMediaFileBlock, changeDisplay, handleAllResourcesDownload } =
    useResourceActions(filters, setFilters)
  const { nextPage, resetPage } = useHandlePagination(filters)
  const { loading: loadingSkeleton, component: componentSkeleton } = useSkeleton()

  useEffect(() => {
    resetPage()
  }, [filters])

  return (
    <>
      {loadingSkeleton && componentSkeleton}

      <div style={{ display: loadingSkeleton ? 'none' : 'block' }}>
        <Header title={t('library')} />
        <SubHeader>
          <ResourceTypeFilter filters={filters} handleChangeFilter={handleChangeFilter} />
        </SubHeader>

        <ContentFilter
          changeDisplay={changeDisplay}
          sectionName={t('library')}
          handleContentSearch={handleSearch}
          handleAllResourcesDownload={handleAllResourcesDownload}
        />

        {display === 1 && (
          <Container style={{ maxWidth: 1111 }} id="grid-cards">
            <LibraryContentCards
              filters={filters}
              handleDownload={handleDownload}
              handleFavorite={handleFavorite}
              handleClickMediaFileBlock={handleClickMediaFileBlock}
              nextPage={nextPage}
            />
          </Container>
        )}

        {display === 0 && (
          <Container style={{ maxWidth: 1111 }}>
            <ResourceTable filters={filters} nextPage={nextPage} />
          </Container>
        )}

        <ResourceNotifications />
      </div>
    </>
  )
}

export default ClientLibrary
